import React from "react";
import IconTile from "./IconTile";
import RewardArt, { rewardArtType } from "./RewardArt";
import AuthenticatedImage from "./AuthenticatedImage";
import { lighten } from "../lib/theme";

// Preserve custom photos and emoji; illustrate supported rewards in the kid shop.
export default function RewardVisual({ reward, color, size = 56, context = "parent", muted = false }) {
  const c = muted ? "#CBD5E1" : color;
  const radius = Math.round(size * 0.32);

  if (reward?.image_path) {
    return (
      <div className="overflow-hidden shrink-0 border-2 border-white shadow-soft" style={{ width: size, height: size, borderRadius: radius }}>
        <AuthenticatedImage path={reward.image_path} context={context} alt={reward.title} className="w-full h-full object-cover" />
      </div>
    );
  }

  const artType = context === "kid" ? rewardArtType(reward) : null;
  if (artType) {
    return <div className="reward-artwork shrink-0" style={{ width: size, height: size }}><RewardArt type={artType} size={size} /></div>;
  }

  if (reward?.emoji) {
    return (
      <div className="grid place-items-center shrink-0" style={{
        width: size, height: size, borderRadius: radius,
        background: `linear-gradient(145deg, ${lighten(c, 60)}, ${c}33)`,
        boxShadow: "inset 0 2px 3px rgba(255,255,255,0.6)",
      }}>
        <span style={{ fontSize: size * 0.5, lineHeight: 1 }}>{reward.emoji}</span>
      </div>
    );
  }

  return <IconTile name={reward?.icon || "gift"} color={c} size={size} />;
}
